import instance from "../root.api";

export const askQuestionRequest = (data) =>
  instance.post("/expert-questions", data).then((response) => ({ response }));
